export default __webpack_public_path__ + "388daf599acc41ea9a01c6a230bf6428.svg";